import React from 'react';
import { EventsQuery, EventRsvpDataQuery } from '../../generated/graphql';
import styles from './rsvpSummaryCard.scss';

export interface BadgeProps {
  color: string;
}

export interface ChartLabelProps {
  responses?: number;
  total?: number;
  isPrivateRsvp?: boolean;
  allResponded?: boolean;
}
export const Badge: React.FC<BadgeProps> = ({ color }) => (
  <div className={styles.badge} style={{ backgroundColor: color }}></div>
);

export const ChartLabel: React.FC<ChartLabelProps> = ({
  responses = 0,
  total = 0,
  isPrivateRsvp = false,
  allResponded = false,
}) => (
  <div className={styles.chartLabel}>
    {allResponded ? (
      <>
        <span className={styles.allResponded}></span>
        <span>Everyone</span>
        <span>responded!</span>
      </>
    ) : (
      <>
        {responses} {isPrivateRsvp ? <span>of {total}</span> : null}
        <span>{isPrivateRsvp ? 'responded' : responses > 1 ? 'responses' : 'responded'}</span>
      </>
    )}
  </div>
);

// create bg color array based on number of values, loops through colors if there are more values.
export const backgroundColors = (colors: string[], values: any[]) => {
  const result: string[] = [];
  let i = 0;
  values.forEach(() => {
    result.push(colors[i]);
    i = (i + 1) % colors.length;
  });

  // avoid first and last colors matching in donut chart
  if (result[0] === result[result.length - 1]) {
    result[result.length - 1] = result[1];
  }

  return result;
};

export const findEventById = (eventData: EventsQuery | undefined, eventId: string) => {
  return eventData?.events.find(event => event.id === eventId);
};

export const findEventRsvpDataById = (rsvpData: EventRsvpDataQuery | undefined, eventId: string) => {
  return rsvpData?.eventRsvpData?.find(event => event.eventId === eventId);
};
